<template>
  <router-link :to="item.to">
    <div
        v-if="item.icon"
        class="icon">
      {{ item.icon }}
    </div>
    <div
        v-else-if="item.customIcon"
        class="custom-icon">
      <component :is="item.customIcon"/>
    </div>
    <span>
      {{ item.text }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'SettingsMenuItem',
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

a {
  align-items: center;
  border-bottom: 0.0625rem solid $dark-gray-900;
  display: flex;
  padding: 0.25rem 0.75rem;
  position: relative;
  transition: background .2s;

  &::before {
    background: transparent;
    bottom: 0;
    content: '';
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: background .2s;
    width: 0.25rem;
  }

  &.router-link-exact-active {
    &::before {
      background: $primary-600;
    }
  }

  &:hover {
    background: $dark-gray-400;
  }

  .icon, .custom-icon {
    margin: 0.25rem;
  }

  .custom-icon {
    height: 1.5rem;
    width: 1.5rem;
  }

  span {
    margin-left: 0.5rem;
  }
}
</style>
